import { getCsrfFromCookie } from "@/shared/utils/getCsrfFromCookie";

export const changeProfile = async ({settingType, value, idToken}: {settingType: string, value: string, idToken: string}): Promise<{ success: boolean; error?: string }> => {
  try {
    const csrf = getCsrfFromCookie();
    
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/changeProfile`, {
        method: "POST",
        credentials: "include",
        headers: {
          'Authorization': `Bearer ${idToken}`,
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf || "",
        },
        body: JSON.stringify({
          setting: settingType,
          value: value,
        }),
    });
      

    if (!response.ok) {
      const text = await response.text();
      return { success: false, error: text || "Logout failed" };
    }

    await response.text();
    return { success: true };
  } catch (err: unknown) {
    if (err instanceof Error) {
      return { success: false, error: err.message };
    } else {
      return { success: false, error: "Network error" };
    }
  }
};